import DemoIcon1 from '../../../assets/icons/WebExperience_LeftNav-Icon1.svg';
import DemoIcon2 from '../../../assets/icons/WebExperience_LeftNav-Icon2.svg';
import DemoIcon3 from '../../../assets/icons/WebExperience_LeftNav-Icon3.svg';
import StreamlineIntroImage from '../../../assets/images/SailPoint-StaticImages_RoleCreation-Intro.png';
import StreamlineOutroImage from '../../../assets/images/SailPoint-StaticImages_RoleCreation-Outro.png';
import ShineIntroImage from '../../../assets/images/SailPoint-StaticImages_SaaSData-Intro.png';
import ShineOutroImage from '../../../assets/images/SailPoint-StaticImages_SaaSData-Outro.png';
import GovernIntroImage from '../../../assets/images/SailPoint-StaticImages_ReviewCloudAccess-Intro.png';
import GovernOutroImage from '../../../assets/images/SailPoint-StaticImages_ReviewCloudAccess-Outro.png';
import PlusAnimation from '../../../assets/animations/SP-BusinessPlus-Animation-v1.0.mp4';
import StreamLine from '../../../assets/images/walnut-screens/Streamline-RoleCreation-Walnut-Screen.png';
import ShineALight from '../../../assets/images/walnut-screens/Shine-A-Light-Walnut-Screen.png';
import GovernTheClouds from '../../../assets/images/walnut-screens/Govern-Cloud-Walnut-Screen.png';

const data = {
  animation: PlusAnimation,
  intro: {
    title: 'Interactive Demos',
    businessHeading: 'See the Business Plus solution in action',
    heading: 'See the solution in action',
    instruction: 'Select a demo to begin'
  },
  demos: [
    {
      id: 6,
      title: 'Streamline',
      actionText: 'role creation',
      descriptionTitle: 'Streamline role creation',
      description: [
        'Building and maintaining access roles is key to maintaining a productive and secure workforce in a least privilege environment.'
      ],
      icon: DemoIcon1,
      illustration: StreamlineIntroImage,
      illustrationOutro: StreamlineOutroImage,
      outroTitle: 'Streamline role creation',
      outroDescription: [
        'Creating and maintaining roles should be easy.  With the power of artificial intelligence and automation, SailPoint helps the modern enterprise maintain least privileged access.'
      ],
      demoIdentifier: 'Access Modeling',
      walnut:
        'https://demo-marketing.sailpoint.com/player/?demoId=3bb8b3f2-d210-4a61-bbb8-22e074964ace&showGuide=true&showGuidesToolbar=false&showHotspots=true&isEmbed=true',
      walnutPlaceholder: StreamLine
    },
    {
      id: 7,
      title: 'Shine a light on',
      actionText: 'shadow IT',
      descriptionTitle: 'Shine a light on shadow IT',
      description: [
        'Uncovering and mitigating SaaS access risks is critical for modern enterprises.  With the ability to see and control all your SaaS applications from a single solution, SaaS Management is a must have.'
      ],
      icon: DemoIcon2,
      illustration: ShineIntroImage,
      illustrationOutro: ShineOutroImage,
      outroTitle: 'Shine a light on shadow IT',
      outroDescription: [
        'Whether you use few SaaS applications or hundreds, SaaS Management can quickly surface your SaaS sprawl, shadow IT, and potential gaps in your SaaS security.'
      ],
      demoIdentifier: 'SaaS Management',
      walnut:
        'https://demo-marketing.sailpoint.com/player/?demoId=2c067b9a-4a31-4f1b-b528-8752f95a3400&showGuide=true&showGuidesToolbar=false&showHotspots=true&isEmbed=true',
      walnutPlaceholder: ShineALight
    },
    {
      id: 8,
      title: 'Govern cloud',
      actionText: 'workloads',
      descriptionTitle: 'Govern cloud workloads',
      description: [
        `Increased cloud infrastructure adoption has underscored the need to closely govern and manage access across multiple cloud service providers, including Microsoft Azure, Amazon Web Services and Google Cloud Platform.  Here's a quick review of why full visibility into cloud entitlements is only possible after evaluation of all access paths and all policies.`
      ],
      icon: DemoIcon3,
      illustration: GovernIntroImage,
      illustrationOutro: GovernOutroImage,
      outroTitle: 'Govern cloud workloads',
      outroDescription: [
        'SailPoint Cloud Access Management is a SaaS-delivered cloud governance solution to certify and provision access to cloud service providers – including AWS, Microsoft Azure, and Google Cloud Platform (GCP).'
      ],
      demoIdentifier: 'Cloud Access Management',
      walnut:
        'https://demo-marketing.sailpoint.com/player/?demoId=64ee2ae6-148f-4178-b022-9d4546ab61c0&showGuide=true&showGuidesToolbar=false&showHotspots=true&isEmbed=true',
      walnutPlaceholder: GovernTheClouds
    }
  ]
};

export default data;
